// ContactFormHeader Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UploadAvatar from '../../../common/form/upload_avatar/upload_avatar.jsx'

class ContactFormHeader extends Component {
  constructor (props) {
    super(props)

    this._message = null
    this._messageTime = null
  }

  static get propTypes () {
    return {
      imageUrl: PropTypes.string,
      companyName: PropTypes.string,
      onUploadSuccess: PropTypes.func,
      onDeleteImage: PropTypes.func,
      onSubmit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      imageUrl: '',
      companyName: '',
      onUploadSuccess: null,
      onDeleteImage: null,
      onSubmit: null
    }
  }

  showMessage (title, info, bSuccess) {
    const message = { title: title, info: info, bSuccess: bSuccess }
    this._message = message
    this.forceUpdate()

    if (this._messageTime) window.clearTimeout(this._messageTime)

    this._messageTime = window.setTimeout(() => {
      this._messageTime = null
      this._message = null
      this.forceUpdate()
    }, 3000)
  }

  render () {
    return (
      <div className='contact-formheader'>
        {this._message && this._renderMessage()}
        <div className='inner'>
          <UploadAvatar
            image={this.props.imageUrl}
            className='contact-upload'
            uploadSuccess={this.props.onUploadSuccess} // eslint-disable-line react/jsx-handler-names
            onDeleteClick={this.props.onDeleteImage}
          />
          <div className='company'>{this.props.companyName}</div>
        </div>
      </div>
    )
  }

  /* Private functions */
  _renderMessage () {
    const message = this._message
    return (
      <div
        className={`formmessage${
          !message.bSuccess ? ' formmessage_error' : ''
        }`}
      >
        <h2 className='title'>{message.title}</h2>
        <p className='content'>{message.info}</p>
      </div>
    )
  }
}

export default ContactFormHeader
